import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as Common from '_common';
import * as Components from '_components';
import { useWidgetRegister } from '_widgetRegister';
import { WidgetContext, useWidgetContext } from './types';
import { WidgetFrame } from './WidgetFrame';
import { getComponent } from '../../types/IWidget';
export function WidgetRender(component, index) {
    function mapType(type) {
        switch (type) {
            case 'MinButton':
                return Common.WidgetSize.MinButton;
            case 'Button':
                return Common.WidgetSize.Button;
            case 'Frame':
                return Common.WidgetSize.Frame;
            case 'FullScreen':
                return Common.WidgetSize.FullScreen;
            default:
                throw new Error(`Unknown widget type: ${type}`);
        }
    }
    const type = mapType(component.properties.type);
    const placeholderType = type === Common.WidgetSize.FullScreen
        ? Common.WidgetPlaceholderType.FullScreen
        : Common.WidgetPlaceholderType.Tiles;
    if (type === Common.WidgetSize.Button || type === Common.WidgetSize.MinButton) {
        return (_jsx(Components.Button, { children: _jsx(Widget, { id: component.properties.id, type: type, placementManager: Common.EMPTY_WIDGET_PLACEMENT_MANAGER, placeholderType: placeholderType }, index) }));
    }
    return (_jsx(Widget, { id: component.properties.id, type: type, placementManager: Common.EMPTY_WIDGET_PLACEMENT_MANAGER, placeholderType: placeholderType }, index));
}
export function Widget(props) {
    const widgets = useWidgetRegister();
    const widget = props.widget ||
        props.placementManager.getWidgetById(props.id) ||
        widgets.find(w => w.id === props.id);
    if (!widget) {
        return _jsxs("div", { children: ["Widget not found: ", props.id] });
    }
    function renderComponent(widget, size) {
        const cmp = getComponent(widget.components, size);
        if (!cmp) {
            if (props.allowFallback) {
                return _jsx(Common.MLT, { text: widget.title });
            }
            return undefined;
        }
        return _jsx(Components.Content, { component: cmp });
    }
    function renderContent(widget) {
        const content = renderComponent(widget, props.type);
        if (content === undefined) {
            return addDefaultFrame(widget, _jsx("div", { children: "Unsupported widget size." }));
        }
        if (!widget.addDefaultFrame) {
            return content;
        }
        return addDefaultFrame(widget, content);
    }
    function addDefaultFrame(widget, children) {
        if (props.type === Common.WidgetSize.Button || props.type === Common.WidgetSize.MinButton) {
            return _jsx(WidgetButton, { children: children });
        }
        return _jsx(WidgetFrame, { ...Components.TilableProps(props), children: children });
    }
    return (_jsx(Common.ErrorBoundary, { children: _jsx(WidgetContext.Provider, { value: {
                id: widget.id,
                config: widget,
                title: widget.title,
                placementManager: props.placementManager,
                placement: props.placement,
                placeholderType: props.placeholderType,
            }, children: renderContent(widget) }) }));
}
export function WidgetButtonRender(component, index) {
    return _jsx(WidgetButton, {});
}
export function WidgetButton(props) {
    const context = useWidgetContext();
    const otherProperties = {};
    if (context.placeholderType === Common.WidgetPlaceholderType.Tiles) {
        otherProperties.tileSize = props.tileSize || Components.TileSize.LongThin;
    }
    function click() {
        if (context.placeholderType === Common.WidgetPlaceholderType.Tiles && context.placement) {
            const newPlacement = { ...context.placement };
            newPlacement.size = Common.WidgetSize.Frame;
            context.placementManager.setPlacement(context.id, newPlacement);
        }
        else {
            context.placementManager.showWidget(context.id);
        }
    }
    return (_jsx(Components.Button, { onClick: click, ...otherProperties, children: props.children || _jsx(Common.MLT, { text: context.title }) }));
}
